module.exports = __webpack_public_path__ + "static/media/newMap.e6b8939f.jpg";